import { createAction, props } from '@ngrx/store';
import { ILicenseRequest, ILicenseResponse, ILicenseUsage } from '../../../../model/license';

export const activateLicenseRequest = createAction(
    '[License] Request Activate License',
    props<{ licenseRequest: ILicenseRequest }>()
);
export const setActiveLicense = createAction(
    '[License] Set Active License',
    props<{ licenseResponse: ILicenseResponse }>()
);
export const setLicenseUsage = createAction('[License] Set License Usage', props<{ licenseUsage: ILicenseUsage }>());
